/** @format */

/* eslint-disable no-bitwise -- CRC-32 for stable planning slot ids */

/** Stable positive int from a string (matches backend schedule entry ids). */
export default function stableCrc32Id(raw) {
  let crc = -1;
  for (let i = 0; i < raw.length; i += 1) {
    crc ^= raw.charCodeAt(i);
    for (let j = 0; j < 8; j += 1) {
      const mask = -(crc & 1);
      crc = (crc >>> 1) ^ (0xedb88320 & mask);
    }
  }
  return ((crc ^ -1) >>> 0) & 0x7fffffff;
}
